import { __assign, __extends } from "tslib";
import React from 'react';
import ImageItem from '../imageItem';
import { GalleryComponent } from '../../galleryComponent';
var VideoItemPlaceholder = /** @class */ (function (_super) {
    __extends(VideoItemPlaceholder, _super);
    function VideoItemPlaceholder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoItemPlaceholder.prototype.render = function () {
        return (React.createElement(ImageItem, __assign({ overlay: this.props.videoPlayButton, extraClasses: ' video-item gallery-item-video' }, this.props)));
    };
    return VideoItemPlaceholder;
}(GalleryComponent));
export default VideoItemPlaceholder;
//# sourceMappingURL=videoItemPlaceholder.js.map